module.exports = __webpack_public_path__ + "img/male_user_icon.a725c5e1.svg";